module.exports = __webpack_public_path__ + "img/feature_buy_ph.a7008d02.png";